import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKey = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M17.0996 7.49961H16.4996M21.8996 7.49961C21.8996 10.4819 19.4819 12.8996 16.4996 12.8996C16.0796 12.8996 15.6709 12.8517 15.2785 12.761L13.6431 14.3996H10.7996V17.2487L10.0502 17.9996H7.19961V20.8559L6.68509 21.3714C6.34743 21.7098 5.88905 21.8999 5.41104 21.8999H2.69961C2.36824 21.8999 2.09961 21.6313 2.09961 21.2999V18.6497C2.09961 18.1729 2.28872 17.7157 2.62544 17.3782L11.2432 8.74183C11.1493 8.343 11.0996 7.92711 11.0996 7.49961C11.0996 4.51727 13.5173 2.09961 16.4996 2.09961C19.4819 2.09961 21.8996 4.51727 21.8996 7.49961Z",
		stroke: "#00897B",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgKey);
export { ForwardRef as ReactComponent };
